/* DefaultValueEditor.js */

"use strict";

/**
 * @type {{Control: {
 *  Textfield: {InputText:InputTextControlComponent, InputNumber:InputNumberControlComponent},
 *  OptionSelection: {Single:{ComboBox:ComboBoxControlComponent}, Multiple:{ComboBox:MultipleComboBoxControlComponent}}
 *  Boolean: {InputCheckbox:InputCheckboxControlComponent}
 * }}}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputTextControl = uiCore.Control.Textfield.InputText;
const InputNumberControl = uiCore.Control.Textfield.InputNumber;
const InputCheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const MultipleComboBoxControl = uiCore.Control.OptionSelection.Multiple.ComboBox;

const CommonEditor = require("./CommonEditor");
const { labelByTypeData, getTypeData } = require("../CustomFieldsConstants");

class DefaultValueEditor extends CommonEditor {
    constructor(options) {
        super(options);
    }

    _createInput(itemData) {
        const type = labelByTypeData(itemData.dataType);
        const typeInfo = itemData.typeInfo || {};
        let input;
        switch (type) {
            case "Boolean":
                input = this._createBooleanInput(typeInfo);
                break;
            case "Number":
                input = this._createNumberInput(typeInfo);
                break;
            case "Dropdown":
                input = this._createSelectInput(typeInfo);
                break;
            case "String":
            /* falls through */
            default:
                input = this._createStringInput(typeInfo);
        }
        return input;
    }

    _createBooleanInput() {
        return new InputCheckboxControl({
            labelShown: false,
            value: false,
            darkTheme: true
        });
    }

    _createNumberInput(typeInfo) {
        typeInfo = typeInfo.Number || {};
        const input = new InputNumberControl({
            darkTheme: true,
            max: typeInfo.max,
            min: typeInfo.min
        });
        input.setAttribute("step", typeInfo.onlyInteger ? "1" : "any");

        return input;
    }

    _createSelectInput(typeInfo) {
        const { ids = [], labels = [], multiSelect = false } = typeInfo;
        const options = ids.map((id, idx) => ({ value: id, label: labels[idx] }));
        const comboboxParams = {
            options: options,
            showFilter: false,
            darkTheme: true,
            adjustWidth: true,
            allowClear: true,
            visible: Boolean(options.length)
        };
        const ComboBoxControl = multiSelect ? MultipleComboBoxControl : SingleComboBoxControl;

        return new ComboBoxControl(comboboxParams);
    }

    _createStringInput(typeInfo) {
        typeInfo = typeInfo.String || {};
        const input = new InputTextControl({ darkTheme: true });
        if (typeInfo.pattern) {
            input.setAttribute("pattern", typeInfo.pattern);
        }
        return input;
    }

    /*****************************/
    /*       PUBLIC API          */
    /*****************************/
    /**
     * is used to apply new data back to Item
     * @param {ItemData} item - grid data Item
     * @param {*} state - result of serializeValue
     */
    applyValue(item, state) {
        const initialDefault = getTypeData(item.dataType).default;

        item[this._fieldName] = state === null ? initialDefault : state;
    }

    /**
     * checks if data is valid
     *
     * @returns {{valid: boolean, msg: ?string}}
     */

    validate() {
        const value = this._getValue();
        const typeInfo = this._itemData.typeInfo;
        const typeData = getTypeData(this._itemData.dataType) || {};

        const validate = typeData.validation;

        return (
            (validate && validate(value, typeInfo)) || {
                valid: true,
                msg: null
            }
        );
    }
}

module.exports = DefaultValueEditor;
